import React from 'react';
import { Box, Chip, Paper, Stack, Typography } from '@mui/material';
import { BOXES } from '../../config/infra';

// "Read-only root" card (HOME-184). The boxes run with their runtime root
// filesystem mounted read-only; the only way to change the OS layer is through
// Ansible, which remounts rw in a controlled window and flips back. That's the
// point: no ad-hoc `apt-get install` on the box to paper over a problem — every
// change goes through the playbook, so the box stays reproducible from IaC.
// Status is read from the inventory (roRoot) rather than hardcoded here.

const RootFsCard: React.FC = () => (
    <Paper sx={{ p: 2 }} data-testid='rootfs-card'>
        <Typography variant='h6' sx={{ mb: 0.5 }}>Read-only root — enforced IaC</Typography>
        <Typography variant='body2' color='text.secondary' sx={{ mb: 2, maxWidth: 720 }}>
            Each box runs with its runtime root filesystem mounted <strong>read-only</strong>.
            The only way to change the OS layer is the Ansible playbook, which remounts
            <code> rw</code> for a controlled window and flips back to <code>ro</code> afterwards.
            No quick <code>apt-get install</code> on the box to fix something — if it isn&apos;t in
            the playbook it doesn&apos;t persist, so every box stays reproducible from IaC and
            drift can&apos;t hide.
        </Typography>

        <Stack direction='row' spacing={2} flexWrap='wrap' useFlexGap>
            {BOXES.map(b => (
                <Box key={b.id} data-testid={`rootfs-${b.id}`} sx={{ minWidth: 140 }}>
                    <Typography variant='subtitle2' sx={{ mb: 0.5 }}>{b.name}</Typography>
                    <Chip
                        size='small'
                        label={b.roRoot ? 'read-only ✓' : 'writable — ro planned'}
                        sx={{
                            backgroundColor: b.roRoot ? '#4db6ac' : '#ffb74d',
                            color: b.roRoot ? '#0b1f1c' : '#3a2600',
                        }}
                    />
                </Box>
            ))}
        </Stack>
    </Paper>
);

export default RootFsCard;
